module.exports = __webpack_public_path__ + "img/index-img-05-02.79a6e6d0.png";